import { Button } from 'antd';
import * as React from 'react';
import MinusOutlined from '@ant-design/icons/MinusOutlined';
import PlusOutlined from '@ant-design/icons/PlusOutlined';

interface BigNumberInputProps{
  defaultValue?: number;
  formRef: any;
}

interface BigNumberInputState{
  value: number;
}

export default class BigNumberInput extends React.Component<BigNumberInputProps, BigNumberInputState>{
  constructor(props: BigNumberInputProps) {
    super(props);
    this.state = {
      value: props.defaultValue ? props.defaultValue : 1
    }
  }

  onClick(operation: string) {
    const { value } = this.state;
    const { formRef } = this.props;
    let currentValue = value;

    switch (operation) {
      case 'minus':
        if (value > 1) {
          currentValue--;
        }
        break;
      case 'plus':
        if (value < 10) {
          currentValue++;
        }
        break;
    }

    formRef.current.setFieldsValue({ number: currentValue });
    this.setState({ value: currentValue });
  }

  render() {
    const { value } = this.state;

    return (
      <div className={'bignumber-container'}>
        <Button className={'bignumber'} onClick={() => this.onClick('minus') }><MinusOutlined /></Button>
        <input className={'bignumber'} value={value} readOnly={true} />
        <Button className={'bignumber'} onClick={() => this.onClick('plus')}><PlusOutlined /></Button>
      </div>
    );
  }
}
